import { db, realtimeDb, firebase } from '@/plugins/firebase';
import * as userServices from '@/services/userServices';
import * as DateTime from '@/utils/date';

export const USER_VIEW_STATUS = {
  "NOTFOUND" : -1,
  "NONE" : 0,
  "FREE" : 1,
  "PAID" : 2,
}

export async function createRecentLive(liveDoc) {
  let success = true;
  const recentLiveDocRef = await db
    .collection('recentLives')
    .add(liveDoc)
    .catch(err => {
      console.error(err);
      success = false;
    });

  if (!success) return false;

  const recentLiveDocSnapshot = await recentLiveDocRef.get();

  if (recentLiveDocSnapshot) {
    const recentLiveDoc = recentLiveDocSnapshot.data();
    recentLiveDoc['id'] = recentLiveDocSnapshot.id;
    return recentLiveDoc;
  }

  return;
}

export async function updateRecentLiveByLiveId(liveId, liveDoc) {
  let success = true;
  const recentLiveDocRef = await db.collection('recentLives').doc(liveId);

  recentLiveDocRef.set(liveDoc, { merge: true }).catch(err => {
    console.error(err);
    success = false;
  });

  if (success) {
    const recentLiveDocSnapShot = await recentLiveDocRef.get();
    return recentLiveDocSnapShot.data();
  }

  return;
}

// limit: ライブ取得数の上限
export async function getAllRecentLives() {
  const recentLiveQuerySnapshot = await db
    .collection('recentLives')
    .orderBy('startAt', 'desc')
    .get();

  if (recentLiveQuerySnapshot.empty) {
    return [];
  }
  let lives = [];
  recentLiveQuerySnapshot.forEach(doc => {
    const live = doc.data();
    lives.push({
      id: doc.id,
      title: live.title,
      performerDocRef: live.performerDocRef,
      thumbnailURL: live.thumbnailURL,
      startAt: DateTime.fromUnixToJSDate(live.startAt.seconds)
    });
  });
  return await arrangeLivesByPerformersUserDocumentResolved(lives);
}

export async function getRecentLivesByPerformerId(performerId, limit) {
  let lives = [];
  const performerDocRef = userServices.getUserDocRef(performerId);

  const recentLiveQuerySnapshot = await db
    .collection('recentLives')
    .where('performerDocRef', '==', performerDocRef)
    .orderBy('startAt', 'asc')
    .limit(limit)
    .get();

  if (recentLiveQuerySnapshot.empty) {
    return lives;
  } else {
    recentLiveQuerySnapshot.forEach(doc => {
      const data = doc.data();
      lives.push({
        id: doc.id,
        title: data.title,
        thumbnailURL: data.thumbnailURL,
        startAt: DateTime.fromUnixToJSDate(data.startAt.seconds),
        upComingStartAt: DateTime.fromUnixToJSDate(data.upComingLive.startAt.seconds),
        upComingEndAt: DateTime.fromUnixToJSDate(data.upComingLive.endAt.seconds),
      });
    });
  }
  return lives;
}

export async function getRecentLiveByLiveId(liveId) {
  const liveDoc = await db.collection('recentLives').doc(liveId).get();
  if (liveDoc) {
    return liveDoc.data();
  } else {
    return null;
  }
}

export async function deleteRecentLiveByLiveId(liveId) {
  let success = true;

  await db
    .collection('recentLives')
    .doc(liveId)
    .delete()
    .catch(err => {
      console.error(err);
      success = false;
    });

  return success;
}

export async function createUpComingLive(liveId, liveDoc) {
  // reference collection of scheduledLives
  try {
    const docRef = await db.collection('upComingLives').doc(liveId);
    await docRef.set(
      {
        ...liveDoc,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      },
      { merge: true }
    );
    const docSnapShot = await docRef.get();
    let result = docSnapShot.data();
    result["id"] = liveId;
    return result;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function updateUpComingLive(liveId, liveDoc) {
  let success = true;
  const upComingLiveDocRef = await db.collection('upComingLives').doc(liveId);

  upComingLiveDocRef.set(liveDoc, { merge: true }).catch(err => {
    console.error(err);
    success = false;
  });

  if (success) {
    const upComingLiveDocSnapShot = await upComingLiveDocRef.get();
    return upComingLiveDocSnapShot.data();
  }

  return;
}

export async function getAllUpComingLives() {
  const upComingLiveQuerySnapshot = await db
    .collection('upComingLives')
    .orderBy('createdAt', 'desc')
    .get();
  if (upComingLiveQuerySnapshot.empty) {
    return [];
  }
  let lives = [];
  upComingLiveQuerySnapshot.forEach(doc => {
    const live = doc.data();
    lives.push({
      id: doc.id,
      title: live.title,
      performerDocRef: live.performerDocRef,
      thumbnailURL: live.thumbnailURL,
      startAt: DateTime.fromUnixToJSDate(live.startAt.seconds)
    });
  });
  return await arrangeLivesByPerformersUserDocumentResolved(lives);
}

export async function getUpcomingLivesByPerformerId(performerId, limit) {
  let lives = [];
  const performerDocRef = userServices.getUserDocRef(performerId);

  // TODO: add logic to do pagination
  const upComingLiveQuerySnapshot = await db
    .collection('upComingLives')
    .where('performerDocRef', '==', performerDocRef)
    .orderBy('startAt', 'asc')
    .limit(limit)
    .get();

  if (upComingLiveQuerySnapshot.empty) {
    return lives;
  } else {
    upComingLiveQuerySnapshot.forEach(doc => {
      const data = doc.data();
      lives.push({
        id: doc.id,
        title: data.title,
        thumbnailURL: data.thumbnailURL,
        startAt: DateTime.fromUnixToJSDate(data.startAt.seconds),
        endAt: DateTime.fromUnixToJSDate(data.endAt.seconds),
      });
    });
  }
  return lives;
}

export async function getUpComingLiveByLiveId(liveId) {
  const liveDoc = await db.collection('upComingLives').doc(liveId).get();

  if (liveDoc && liveDoc.exists) {
    const data = liveDoc.data();
    return {
      id: liveDoc.id,
      title: data.title,
      thumbnailURL: data.thumbnailURL,
      performerDocRef: data.performerDocRef,
      startAt: DateTime.fromUnixToJSDate(data.startAt.seconds),
      endAt: DateTime.fromUnixToJSDate(data.endAt.seconds),
      reserveStartAt: data.reserveStartAt ? DateTime.fromUnixToJSDate(data.reserveStartAt.seconds) : null,
      reserveEndAt: data.reserveEndAt ? DateTime.fromUnixToJSDate(data.reserveEndAt.seconds) : null
    };
  } else {
    return null;
  }
}

export async function deleteUpComingLiveByLiveId(liveId) {
  let success = true;

  await db
    .collection('upComingLives')
    .doc(liveId)
    .delete()
    .catch(err => {
      console.error(err);
      success = false;
    });

  return success;
}

export async function getEndedLivesByUserId(userId) {
  let lives = [];

  const endedLivesQuerySnapshot = await db
    .collection('endedLives')
    .where('userId', '==', userId)
    .get();

  if (endedLivesQuerySnapshot.empty) {
    return lives;
  } else {
    endedLivesQuerySnapshot.forEach(doc => {
      const data = doc.data();
      lives.push({
        id: doc.id,
        title: data.title,
        thumbnailURL: data.thumbnailURL,
        startAt: DateTime.fromUnixToJSDate(data.startAt.seconds)
      });
    });
  }

  return lives;
}

export async function updateEndedLiveByLiveId(liveId, liveDoc) {
  let success = true;
  const endedLiveDocRef = await db.collection('endedLives').doc(liveId);
  endedLiveDocRef.set(liveDoc).catch(err => {
    success = false;
    console.error(err);
  });

  if (success) {
    const endedLiveDocSnapShot = await endedLiveDocRef.get();
    return endedLiveDocSnapShot.data();
  }

  return;
}

export async function getLiveCommentRefObj(liveId) {
  return await realtimeDb.ref(`liveComments/${liveId}`);
}

export async function getCastListWithTodayLive() {
  var castList = {};

  const recentLiveQuerySnapshot = await db.collection('recentLives').get();

  if (!recentLiveQuerySnapshot.empty) {
    for (let doc of recentLiveQuerySnapshot.docs) {
      const performerDocRef = doc.data().performerDocRef;
      const id = performerDocRef.id

      if (!castList[id]) {
        const performerDoc = await userServices.getUserDoc(id);
        if (performerDoc) {
          performerDoc.id = id;
          castList[id] = performerDoc;
          castList[id].liveId = doc.id;
          castList[id].liveType = "recentLive";
        }
      }
    }
  }

  const upComingLiveQuerySnapshot = await db.collection('upComingLives').get();

  if (!upComingLiveQuerySnapshot.empty) {
    let nowYMD = (await DateTime.serverDate()).toFormat('yyyyMMdd');

    for (let doc of upComingLiveQuerySnapshot.docs) {
      const data = doc.data();
      const startYMD = toYMD(data.startAt.seconds);
      const endYMD = toYMD(data.endAt.seconds);
      const performerDocRef = data.performerDocRef;
      const id = performerDocRef.id

      if (nowYMD == startYMD || nowYMD == endYMD) {
        if (!castList[id]) {
          const performerDoc = await userServices.getUserDoc(id);
          if (performerDoc) {
            performerDoc.id = id;
            castList[id] = performerDoc;
            castList[id].liveId = doc.id;
            castList[id].liveType = "upComingLive";
          }
        }
      }
    }
  }

  return Object.values(castList);
}

export async function checkUserViewStatus(liveId, userId) {
  let liveDoc = await getRecentLiveByLiveId(liveId);
  if (!liveDoc) {
    return USER_VIEW_STATUS.NOTFOUND;
  }

  if (liveDoc.paidViewUsers && liveDoc.paidViewUsers.includes(userId)) {
    return USER_VIEW_STATUS.PAID;
  }

  if (liveDoc.freeViewUsers && liveDoc.freeViewUsers.includes(userId)) {
    return USER_VIEW_STATUS.FREE;
  }

  return USER_VIEW_STATUS.NONE;
}

function toYMD(seconds) {
  return DateTime.fromUnix(seconds).toFormat('yyyyMMdd');
}

// プロパティ performerDocRefのReference型を使ってUserDocumentの値を解決する
async function arrangeLivesByPerformersUserDocumentResolved(lives) {
  return await Promise.all(
    lives.map(async live => {
      const performerDocRef = live.performerDocRef;
      const performerDocSnapshot = await performerDocRef?.get();
      const performer = performerDocSnapshot?.data();
      live.performerNickname = performer ? performer.nickname : '名無しさん';
      live.categories = performer ? performer.categories : [];
      // firebaseインスタンスが持つ参照を削除
      delete live.performerDocRef;
      return live;
    })
  );
}
